export const bottomNavConfig = {
  screens: [
    {
      id: 'levels',
      iconKey: 'levels',
      label: 'Levels',
      action: 'goToLevels'
    },
    {
      id: 'rank',
      iconKey: 'ranking',
      label: 'Rank',
      action: 'goToRank'
    },
    {
      id: 'map',
      iconKey: 'map',
      label: 'Map',
      action: 'goToMap',
      primary: true
    },
    {
      id: 'profile',
      iconKey: 'profile',
      label: 'Profile',
      action: 'goToProfile'
    },
    {
      id: 'shop',
      iconKey: 'shop',
      label: 'Shop',
      action: 'goToShop'
    }
  ]
};

export const homeButtonsConfig = {
  leftButtons: [
    {
      id: 'ranking',
      iconKey: 'ranking',
      label: 'Ranking',
      action: 'goToRanking'
    },
    {
      id: 'progress',
      iconKey: 'progress',
      label: 'Map',
      action: 'goToProgress'
    }
  ],
  rightButtons: [
    {
      id: 'settings',
      iconKey: 'settings',
      label: 'Settings',
      action: 'goToSettings'
    }
  ]
};
